<igx-grid #gridDiferencias [data]="dataDiferencias" [height]="'100%'" [width]="'100%'" [locale]="localGrid"
          [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [moving]="true">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}"
                          (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <app-mas-opciones-grid [arrayDatosAVer]="[0, 1, 2, 6]"
                             (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Codigo" header="{{'GRIDS.DIFERENCIA.COL_CODIGO' | translate}}" width="150px" [dataType]="'string'"
              [resizable]="true" [sortable]="true" />
  <igx-column field="Campo" header="{{'GRIDS.DIFERENCIA.COL_CAMPO' | translate}}" width="170px" [dataType]="'string'"
              [resizable]="true" [sortable]="true" />
  <igx-column field="ValorActual" header="{{'GRIDS.DIFERENCIA.COL_VAL_OBRA' | translate}}" width="230px"
              [dataType]="'string'" [resizable]="true" [sortable]="true" />
  <igx-column field="ValorNuevo" header="{{'GRIDS.DIFERENCIA.COL_VAL_MAESTRO' | translate}}" width="280px"
              [dataType]="'string'" [resizable]="true" [sortable]="true" />
  <igx-column field="Accion" header="{{'GRIDS.DIFERENCIA.COL_ACCION' | translate}}" width="120px" [dataType]="'string'"
              [resizable]="true" [sortable]="true" [editable]="true">
    <ng-template igxCellEditor let-cell="cell">
      <igx-select class="cell-select" [(ngModel)]="cell.editValue" [igxFocus]="true">
        @for (accion of acciones; track accion) {
          <igx-select-item [value]="accion">
            {{ accion }}
          </igx-select-item>
        }
      </igx-select>
    </ng-template>
  </igx-column>
</igx-grid>
